<template>
  <div
    class="d-flex flex-column align-center justify-center pa-10"
    data-locator="document-search-empty"
    style="min-height: 256px;"
  >
    <app-material-icon name="search" color="grey-600" class="mb-4" />
    <p v-if="isRecentFilesSearch" class="text-grey-800 text-center">
      {{ $t('common.document-search.DocumentSearchEmptyState.noRecentFiles') }}
    </p>
    <template v-else>
      <p class="text-body-1 text-grey-900 font-weight-medium mb-2 text-center">
      {{ $t('common.document-search.DocumentSearchEmptyState.noResults') }}
      </p>
      <p class="text-caption text-grey-600 text-center">
        {{ $t('common.document-search.DocumentSearchEmptyState.tryAnotherTerm') }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const isRecentFilesSearch = computed(() => store.state.documents.isRecentFilesSearch)
</script>